import OccupationalTaxItem from 'components/SharedComponents/OcuppationalTaxItem/OccupationalTaxItem';
import { withOccupationalTaxItemProps } from 'viewModel/sharedComponents/occupationalTaxItem/withOccupationalTaxItemProps';

const WrappedOccupationalTaxItem = withOccupationalTaxItemProps(OccupationalTaxItem);

export default WrappedOccupationalTaxItem;
